module.exports = __webpack_public_path__ + "img/1437177288.9e777f89.jpg";